module.exports = __webpack_public_path__ + "static/img/1.03825aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/aboutUs/1.png
// module id = Fi+1
// module chunks = 1